import { forwardRef, Inject, Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { Permissions } from '../../common/constants';
import { AuthenticationService } from '../../service/authentication.service';

@Injectable()
export class RuleGuard implements CanActivate {

    constructor(
        @Inject(forwardRef(() => AuthenticationService)) private authenticationService: AuthenticationService
    ) { }

    canActivate(): Observable<boolean> | Promise<boolean> | boolean {
        return this.authenticationService.hasPermission(Permissions.READ_RULE) || this.authenticationService.hasPermission(Permissions.WRITE_RULE);
    }
}